import { getContentByLocale } from "../content";
import { useI18n } from "../i18n";
import { PageSeo } from "../components/seo/PageSeo";
import { StoryView } from "../views/home/StoryView";

export function HistoryPage() {
  const { locale } = useI18n();
  const content = getContentByLocale(locale);

  return (
    <>
      <PageSeo
        title={`${content.story.title} | ${content.seo.defaultTitle}`}
        description={content.story.paragraphs[0] ?? content.seo.defaultDescription}
      />
      <StoryView
        title={content.story.title}
        image={content.story.image}
        imageAlt={content.story.imageAlt}
        paragraphs={content.story.paragraphs}
      />
    </>
  );
}
